<template>
  <div class="exam-outline">
    <MainHeader></MainHeader>  
    <div class="main">
      <!-- <div class="left-mian">
        <div class="left-item" :class="{act:titleIndex==index}" v-for="(item,index) in titleL" :key="index" @click="titleClick(index)" v-html="item.name" @mousemove="titleActive(index)"></div>
      </div> -->
      <div class="right-mian">
        <div class="item-wrap" v-for="(item,index) in contentL" :key="index" @click="pathTo(item)">
          <div class="item">
            <span class="item-name">{{ item.name }}</span>
            <span>{{item.time}}</span>
          </div>
          <el-divider></el-divider>
        </div>
      </div>
    </div>
    <div class="introduce">
      <div class="detail">
        <div class="brand">
          <img src="../assets/img/logo1.png" class="logo" alt="">
          <img src="../assets/img/logo2.png" class="logo1" alt="">
        </div>
        <div class="detail-nev">
          <div class="content_wrap">
            <div class="item">华警教育公司是一家由刘松、罗得水、栾翰林……等在公安联考、公务员考前培训行业从事10+年以上的一批资深老师共同成立的一家培训机构,专注于为全国警校生提供高质量联考培训服务的企业。针对公安联考考试设有独立的师资研究院,其中包括公安专业知识研究院、申论研究院、行测研究院、面试研究院.“四大研究院”共23名拥有一支10年以上行业经验的大咖,专注于研发最新的考试大纲和教授最新考试趋势内容,能够根据警校生的需求和特点，量身定制个性化的教学方案，科学的帮助学生提升在联考中拿到高分。</div>
            <div class="item">华警教育秉承“忠党爱国、锐意进取”的教育理念,致力于为学员提供全方位的招警考试培训解决方案。</div>
            <div class="item">为了保证教育培训服务的质量和效果，华警研究院采用了一系列先进的教学方法和教学技术。课程内容丰富多彩，涵盖了多个层次和难度，从基础系统到巩固提升、从巩固提升提升到强化刷题、从强化刷题到考前冲刺、让警校学子分阶段学习和吸收,在学习中感受到稳步提升。</div>
          </div>
          <div class="chat">
            <img src="../assets/img/chat.png" alt="">
            <p style="margin-top: 5px;">电话：18627592835</p>
            <p>邮箱：327815144@qq.com</p>
            <p>地址：中国（湖南）自由贸易试验区郴州片区郴州市白露塘镇林邑大道东侧郴州市战略性新兴产业园1.2栋701-C348室</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
export default {
  components:{
    MainHeader
  },
  data() {
    return {
      titleIndex: 0,
      titleL: [{ name: '政策解读' }],
      contentL:[
        {name:'公安联考',time:'2022-04-07',id:1},
        {name:'行政职业能力测验科目考生模拟测试说明及考生须知',time:'2022-03-22',id:2},
        {name:'中央机关及其直属机构2022年度考试录用公务员公共科目笔试考试大纲',time:'2022-03-19',id:3},
        {name:'2021年度公安机关人民警察职位专业科目考试大纲（公安院校公安专业毕业生',time:'2022-03-16',id:4},
      ]
    }
  },
  methods:{
    titleActive(index) {
      this.titleIndex = index
    },
    pathTo(item) {
      this.$router.push({
        path: 'OutlineDetail',
        query: {
          id:item.id
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.exam-outline {
  padding-top: 86px;
  height: calc(100% - 37px);
  overflow: auto;
  .main {
    border-radius: 5px;
    background-color: #fff;
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    height: calc(100% - 10px);
    overflow: hidden;
    // box-shadow: 0px 12px 20px 0px rgba(208, 208, 208, 0.5);
    box-shadow: 0px 12px 20px 0px rgba(193, 193, 193, 0.7);
    display: flex;
    .left-mian {
      width: 150px;
      margin: 10px 0;
      .left-item {
        font-size: 16px;
        padding: 20px 10px 20px 13px;
        display: flex;
        justify-content: flex-end;
        text-align: end;
        > p {
          font-size: 16px;
        }
      }
      .act {
        background-color: #49c1d92e;
        border-right: 2px solid #4384f4;
        font-size: 20px;
      }
    }
    .right-mian {
      height: 100%;
      overflow-y: auto;
      padding: 0 10px;
      // width: calc(100% - 150px);
      width: 100%;
      box-shadow: -5px 0 10px -5px rgba(208, 208, 208, 0.5);
      .el-divider--horizontal {
        margin: 10px 0;
        background-color: #eeeeeeaf;
      }
      .item {
        padding: 20px 20px 20px 10px;
        display: flex;
        justify-content: space-between;
        cursor: pointer;
        span{
          font-size: 15px;
        }
        .item-name:hover{
          color:#4384f4
        }
      }
    }
  }
  .introduce {
    background-color: #fff;
    width: 100%;
    margin-top: 20px;
    .detail {
      margin: 0 auto;
      width: 100%;
      max-width:1206px;

      .brand {
        padding-top: 60px;
        display: flex;
        align-items: center;

        .logo {
          height: 66px;
        }

        .logo1 {
          height: 40px;
        }

      }

      .detail-nev {
        margin-top: 34px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .content_wrap {
          width: 80%;

          .item {
            color: #999999;
            text-indent: 2em;
            font-size: 16px;
            line-height: 40px;
          }
        }

        // .adress-warp{
        //   width: 20%;
        // }
        .chat {
          width: 15%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          p {
            line-height: 19px;
          }
        }
      }
    }
  }
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }
}

</style>